exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=botpress-discord__[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/views/style.scss
// module id = 4
// module chunks = 0